export const START_ROUTE_LOADING = "Iniciando carregamento da rota";
export const FINISH_ROUTE_LOADING = "🔃 Carregamento de rota finalizado";
export const START_API_LOADING = "🔃 Iniciado carregamento de API";
export const FINISH_API_LOADING = "🔃 Carregamento de API finalizado";
export const CLEAR_API_LOADING = "🔃 Carregamento de API resetado";
export const SET_ACCESS_TOKEN = "Token definido";
export const SET_USER = "Usuário definido";
export const SET_PERMISSIONS = "Permissões definidas";
export const SET_COLOR = "Define cor do template";
export const SET_EXCEPTION = "Exceção definida";
export const CLEAR_EXCEPTION = "Exceção limpada";
export const SET_VERIFY_EMAIL = "Exceção de verificação de email";
export const CLEAR_VERIFY_EMAIL = "clearVerifyEmail";
export const SET_INSERT_PASSWORD = "Exceção de senha vazia";
export const CLEAR_INSERT_PASSWORD = "clearInsertPassword";
export const SET_SETTINGS = "Configurações definidas";
export const SHOW_INVALID_CREDENTIALS_MODAL = "Mostrar Modal de Credencial Invalida";
